import log from '../utils/logger.js'

import bgController from './bigfarm/bf-controller.js'
import emController from './empire/em-controller.js'

const GAMES_MAP = new Map([
    [12, emController],
    [15, bgController]
])

export const getGameController = (cxf) => {
    const gameId = Number.parseInt(cxf.gameId, 10)
    if (GAMES_MAP.has()) {
        log.error(
            `Game controller is not registered for the game - [${gameId}]`
        )
    }

    console.log(gameId)
    console.log(GAMES_MAP.get(gameId))
    return GAMES_MAP.get(gameId)
}
